<template>
  <div>
    <ol class="am-breadcrumb" v-if="id">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li>
        <router-link :to="{path:'/edit/pages'}">独立页面</router-link>
      </li>
      <li class="am-active" v-if="id">{{title}}</li>
    </ol>
    <ol class="am-breadcrumb" v-else>
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">撰写</li>
      <li class="am-active">创建页面</li>
    </ol>
    <div class="am-form" v-show="editor">
      <div class="am-form-group">
        <label for="title">页面标题</label>
        <input id="title" type="text" class="am-form-field am-radius" placeholder="请输入页面标题..." v-model="title"/>
      </div>
      <div class="am-form-group">
        <label for="slug">页面缩略名</label>
        <input id="slug" type="text" class="am-form-field am-radius" placeholder="请输入页面缩略名..." v-model="slug"/>
      </div>
      <div class="am-form-group">
        <label for="content">页面内容</label>
        <textarea id="content" class="am-form-field am-radius" placeholder="请输入页面内容..." rows="20" v-model="content"></textarea>
      </div>
      <div class="am-form-group">
        <label for="status">页面公开度</label>
        <select id="status" v-model="status">
          <option value="1">公开</option>
          <option value="2">隐藏</option>
          <option value="3">密码保护</option>
          <option value="4">私密</option>
        </select>
        <span class="am-form-caret"></span>
      </div>
      <div class="am-form-group" v-show="status==3">
        <label for="password">页面密码</label>
        <input id="password" type="text" class="am-form-field am-radius" placeholder="请输入页面密码..." v-model="password"/>
      </div>
      <div class="am-form-group">
        <label class="am-radio-inline">
          <input type="radio" name="allowComment" value="true" v-model="allowComment"> 允许评论
        </label>
        <label class="am-radio-inline">
          <input type="radio" name="allowComment" value="false" v-model="allowComment"> 不允许评论
        </label>
      </div>
      <div class="am-form-group am-margin-top">
        <button class="am-btn am-btn-primary am-btn-xs" @click="save">保存</button>
        <button class="am-btn am-btn-secondary am-btn-xs" @click="preview">预览</button>
      </div>
    </div>
    <div v-show="!editor">
      <article class="am-article">
        <div class="am-article-hd">
          <h1 class="am-article-title">
            {{title}}
            <button class="am-btn am-btn-secondary am-btn-xs" @click="edit">返回编辑</button>
            <button class="am-btn am-btn-primary am-btn-xs" @click="save">保存</button>
          </h1>
        </div>
        <div v-highlight class="am-article-bd" v-html="html"></div>
      </article>
    </div>
    <ol class="am-breadcrumb" v-if="id">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li>
        <router-link :to="{path:'/edit/pages'}">独立页面</router-link>
      </li>
      <li class="am-active" v-if="id">{{title}}</li>
    </ol>
    <ol class="am-breadcrumb" v-else>
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">撰写</li>
      <li class="am-active">创建页面</li>
    </ol>
  </div>
</template>

<script>
import marked from 'marked'
import hljs from "highlight.js"
import 'highlight.js/styles/vs2015.css'
import { adminPageGet, adminPageSave } from '@/request'
import {Toast} from "mint-ui"
export default {
  name: 'EditPage',
  data () {
    return {
      editor: true,
      id: null,
      slug: null,
      title: '',
      content: '',
      allowComment: false,
      status: 4,
      password: ''
    }
  },
  mounted () {
    this.resetData()
  },
  computed: {
    html () {
      return marked.parse(this.content)
    }
  },
  watch: {
    $route: {
      handler: 'resetData'
    },
    title (val) {
      document.title = `${val}｜编辑`
    }
  },
  methods: {
    resetData () {
      const slug = this.$route.params.slug
      if(slug) {
        adminPageGet({ slug }).then(res => {
          this.id = res.id
          this.slug = res.slug
          this.title = res.title
          this.content = res.content
          this.allowComment = res.allowComment
          this.status = res.status
          this.password = res.password
        })
      }
      const renderer = new marked.Renderer()
      const linkRenderer = renderer.link
      renderer.link = (href, title, text) => {
        const html = linkRenderer.call(renderer, href, title, text)
        return html.replace(/^<a /, '<a target="_blank" ')
      }
      marked.setOptions({
        renderer: renderer,
        pedantic: false,
        gfm: true,
        tables: true,
        breaks: true,
        sanitize: false,
        smartLists: true,
        smartypants: false,
        xhtml: false
      })
    },
    preview () {
      this.editor = false
    },
    edit () {
      this.editor = true
    },
    save () {
      adminPageSave({
        id: this.id,
        slug: this.slug,
        title: this.title,
        content: this.content,
        allowComment: this.allowComment,
        status: this.status,
        password: this.password
      }).then(res => {
        this.id = res
        Toast("保存成功")
        this.$router.push({path:`/edit/page/${this.slug}`})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditPage.vue